module.exports = __webpack_public_path__ + "images/c648a6cef29c0f026d109dbc0a39d9ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-characters05.jpg
// module id = ./webpack/assets/img/diaryofanant-characters05.jpg
// module chunks = 0